module.exports = __webpack_public_path__ + "img/arrow_up_icon.22f8f7b3.svg";